import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "./store";
import { User } from "../repository/auth.default";
import { jwtVerify, decodeJwt, JWTPayload } from "jose";

export interface Auth {
  readonly token: string;
  readonly refreshToken: string;
}

export interface Payload extends JWTPayload {
  readonly permissions: string;
}

export interface AuthorizeState {
  readonly auth?: Auth | null;
  readonly user?:
    | (User & {
        readonly avatarSrc?: string;
        readonly userCmpLogoSrc?: string;
      })
    | null;
}

const initialState: AuthorizeState = {};

export const authorizeSlice = createSlice({
  name: "authorize",
  initialState,
  reducers: {
    signIn: (state, action: PayloadAction<Auth>) => {
      state.auth = action.payload;
    },
    signOut: (state) => {
      state.auth = null;
    },
    setUser: (
      state,
      action: PayloadAction<
        | (User & {
            readonly avatarSrc?: string;
          })
        | null
      >,
    ) => {
      state.user = action.payload;
    },
  },
});

const authSelector = (state: RootState) => state.authorize.auth;
const userSelector = (state: RootState) => state.authorize.user;
const userPayloadSelector = (
  state: RootState,
):
  | (Payload & {
      readonly role?: string;
    })
  | null => {
  if (!state.authorize.auth?.token) {
    return null;
  }

  let payload = decodeJwt(state.authorize.auth?.token!) as Payload;

  return payload;
};

// Selectors
export const authorizeSelectors = {
  auth: authSelector,
  user: userSelector,
  payload: userPayloadSelector,
};

// Actions
export const authorizeActions = authorizeSlice.actions;
